<template>
  <div class="row brands-slider-widget">
    <div class="col">
      <div class="brands_slider_container">
        <div
          v-if="categoryChildren"
          :id="'brand-slider-' + _uid"
          class="owl-carousel owl-theme brands_slider"
        >
          <a
            v-for="(category, index) in categoryChildren"
            v-if="category.details"
            :key="index"
            :href="getCategoryUrl(category.url)"
            :title="category.details[0].metaTitle"
            class="item"
          >
            <img
              v-if="category.details[0].image2Path"
              class="owl-lazy"
              :data-src="'/documents/' + category.details[0].image2Path"
              :alt="category.details[0].name"
              loading="lazy"
            >
          </a>
        </div>
        <div class="brands_nav brands_prev">
          <i class="fa fa-chevron-left" />
        </div>
        <div class="brands_nav brands_next">
          <i class="fa fa-chevron-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    name: "BrandSlider",
    props: {
        categoryId: {
            type: Number,
            default: 823
        },
        chunkSize:
        {
            type: Number,
            default: 50,
            validator: function (value)
            {
                return value >= 0 && Number.isInteger(value)
            }
        }
    },
    computed: {
        ...mapState({
            categoryChildren: state => state.navigation.categoryChildren
        })
    },
    mounted ()
    {
        this.loadChunk()
    },
    methods: {
        loadChunk ()
        {
            this.$store.dispatch("loadCategoryChildrenChunk", { categoryId: this.categoryId, size: this.chunkSize }).then(() => this.initOwl())
        },
        getCategoryUrl (url)
        {
            const trailingSlash = url[0] === "/" ? "" : "/"
            const prefix = App.urls.includeLanguage ? `/${App.language}${trailingSlash}` : ""

            return prefix + url
        },
        initOwl ()
        {
            const owl = $("#brand-slider-" + this._uid)
            const brandsPrev = $(".brands_prev")
            const brandsNext = $(".brands_next")

            owl.owlCarousel({
                loop: true,
                autoplay: true,
                autoplayTimeout: 3000,
                nav: false,
                dots: false,
                autoWidth: false,
                margin: 15,
                fluidSpeed: true,
                autoplayHoverPause: true,
                center: true,
                lazyLoad: true,
                lazyLoadEager: 1,
                responsive: {
                    0: { items: 3 },
                    480: { items: 4 },
                    768: { items: 5 },
                    950: { items: 6 },
                    1100: { items: 7 }
                }
            })
            if (brandsPrev.length)
            {
                brandsPrev.on("click", function ()
                {
                    owl.trigger("prev.owl.carousel")
                })
            }
            if (brandsNext.length)
            {
                brandsNext.on("click", function ()
                {
                    owl.trigger("next.owl.carousel")
                })
            }
        }
    }
}
</script>
